// test921
(921 && 0);
